import { render, staticRenderFns } from "./BalanceAccount.vue?vue&type=template&id=7ef0f74c&scoped=true"
import script from "./BalanceAccount.vue?vue&type=script&lang=js"
export * from "./BalanceAccount.vue?vue&type=script&lang=js"
import style0 from "./BalanceAccount.vue?vue&type=style&index=0&id=7ef0f74c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef0f74c",
  null
  
)

export default component.exports